import { render, staticRenderFns } from "./LiquidacionesBackofficeView.vue?vue&type=template&id=54e29f6d&"
import script from "./LiquidacionesBackofficeView.vue?vue&type=script&lang=js&"
export * from "./LiquidacionesBackofficeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports